import $ from 'jquery';

let naviIsOpen = false;

function openNavigation() {
  $('#toggle').addClass('active');
  $('#mainNav').addClass('open');

  $('#toggle').addClass('over_menu');

  naviIsOpen = true;
}

function closeNavigation() {
  $('#mainNav').addClass('closing');

  setTimeout(function () {
    $('#mainNav').removeClass('open');
    $('#toggle').removeClass('active');
    $('#toggle').removeClass('over_menu');
    $('.header_icon').removeClass('over_menu');

    naviIsOpen = false;
  }, 500);

  setTimeout(function () {
    $('#mainNav').removeClass('closing');
  }, 1000);
}

class ModuleNavigation {
  init() {
    this.show();
    this.initListener();
    this.onScroll();
  }

  show = () => {
    setTimeout(function () {
      $('.navbar')
        .delay(1500)
        .queue(function () {
          $(this).addClass('show');
          $('#toggle').addClass('show');
          $('.logo').addClass('show');
        });
    }, 0);
  };

  initListener = () => {
    $('#toggle').click(function () {
      if (naviIsOpen === false) {
        openNavigation();
      } else {
        closeNavigation();
      }
    });

    $('#mainNav').click(function () {
      closeNavigation();
    });

    $('.menu_item').click(function () {
      closeNavigation();
    });
    $('.menu_item_scroll').click(function (e) {
      e.preventDefault();
      const aid = $(this).attr('href');
      $('html,body').animate({ scrollTop: $(aid).offset().top }, 500);
    });
  };



  onScroll = () => {
    jQuery(window)
      .scroll(function () {
        let scrollPos = $(document).scrollTop();

        if(scrollPos > 200) {
          // scale down logo
          $('.logo').addClass('scaleDown');
        }
        else {
          // scale up logo
          $('.logo').removeClass('scaleDown');
        }
      }).scroll();
  };
}

export default ModuleNavigation;
